export default __webpack_public_path__ + "static/media/image-phone@3x.cc06e216.png";